import { render, staticRenderFns } from "./exportgameData.vue?vue&type=template&id=18036661&"
import script from "./exportgameData.vue?vue&type=script&lang=js&"
export * from "./exportgameData.vue?vue&type=script&lang=js&"
import style0 from "./exportgameData.vue?vue&type=style&index=0&id=18036661&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports